module.exports = __webpack_public_path__ + "img/P150T_weapon_15.9a3e6467.png";